import {
  MedicationTypeModel,
  IMedicationTypeModel,
  IModel,
  Model,
  ModelRecord,
} from '@common/models';

export interface IVisitAnesthesiaFormPreOpMedicationModel extends IModel {
  visitAnesthesiaFormPreOpMedicationId: number;
  visitAnesthesiaFormPreOpId: number;
  medicationTypeId: number;
  salesItemId: number;
  dose: string;
  totalAmount: string;
  route: string;
  site: string;
  timeAdmin: string;
  initials: string;
  notes: string;
  medicationType: IMedicationTypeModel;
  rowIndex: number; //this is a client side property only to track index of the collection for inline editing.
}

export class VisitAnesthesiaFormPreOpMedicationModel
  extends Model
  implements ModelRecord<IVisitAnesthesiaFormPreOpMedicationModel>
{
  visitAnesthesiaFormPreOpMedicationId: number;
  visitAnesthesiaFormPreOpId: number;
  medicationTypeId: number;
  salesItemId: number;
  dose: string;
  totalAmount: string;
  route: string;
  site: string;
  timeAdmin: string;
  initials: string;
  notes: string;
  medicationType: MedicationTypeModel;
  rowIndex: number;
  constructor(params?: Partial<IVisitAnesthesiaFormPreOpMedicationModel>) {
    super(params);
    this.visitAnesthesiaFormPreOpMedicationId = _.defaultTo(
      params?.visitAnesthesiaFormPreOpMedicationId,
      0,
    );
    this.visitAnesthesiaFormPreOpId = _.defaultTo(
      params?.visitAnesthesiaFormPreOpId,
      0,
    );
    this.medicationTypeId = _.defaultTo(params?.medicationTypeId, 0);
    this.salesItemId = _.defaultTo(params?.salesItemId, 0);
    this.dose = _.defaultTo(params?.dose, '');
    this.totalAmount = _.defaultTo(params?.totalAmount, '');
    this.route = _.defaultTo(params?.route, '');
    this.site = _.defaultTo(params?.site, '');
    this.timeAdmin = _.defaultTo(params?.timeAdmin, '');
    this.initials = _.defaultTo(params?.initials, '');
    this.notes = _.defaultTo(params?.notes, '');
    this.medicationType = params?.medicationType
      ? new MedicationTypeModel(params.medicationType)
      : new MedicationTypeModel();
    this.rowIndex = _.defaultTo(params?.rowIndex, 0);
  }
}
